<template>
    <span v-if="time" class="timestamp tooltip-bottom" :data-tooltip="fullTime" >
        {{prefix}} {{ cuteTime }}
    </span>
</template>

<script>
    import epoch from 'epoch.js'
    
    export default {
        props: {
          'time': {
            required: true
          },
          'prefix': {
            default: ''
          }
        },
        data () {
          return {
            fullTime: null,
            cuteTime: null
          }
        },
        created () {
          this.fullTime = epoch(this.time).format('ddd MMM D, H:mma')
          this.cuteTime = epoch().from(this.time)
          setInterval(() => {
              this.fullTime = epoch(this.time).format('ddd MMM D, H:mma')
              this.cuteTime = epoch().from(this.time)
          }, 15000)
        }
    }
</script>

<style scoped lang="less">
    .timestamp {
      white-space: nowrap;
    }
</style>
